"use strict";

exports.__esModule = true;
exports.PlantTwinRoutes = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _System = require("../../../System");
var _PlantTwinScreen = require("../PlantTwinScreen");
var _DeviceCollection = require("../../Device/DeviceCollection");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _Core = require("../../Core");
var _CheckAccessRoute = require("../../Core/CheckAccessRoute");
var _reactRouterPathGroup = require("../../../Utils/reactRouterPathGroup");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Devices Route
 */
var PlantTwinRoutes = exports.PlantTwinRoutes = (0, _reactRouterCompat.withRouter)(function (props) {
  var active = (0, _reactRouterPathGroup.usePathGroupActive)([(0, _System.getScreenPath)("PlantTwin")]);
  function onData() {
    var history = props.history;
    history.push((0, _System.getScreenPath)("PlantTwin"));
  }
  if (!active) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_DeviceCollection.DeviceCollection, null, function (collection) {
    return /*#__PURE__*/_react["default"].createElement(_DeviceCollection.DeviceCollectionContext.Provider, {
      value: collection
    }, /*#__PURE__*/_react["default"].createElement(_Core.AsyncLoader, {
      load: load,
      params: collection,
      onData: onData
    }, function (_ref) {
      var data = _ref.data,
        error = _ref.error;
      if (error) {
        return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
          error: error
        });
      }
      if (!data) {
        return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
      }
      return /*#__PURE__*/_react["default"].createElement(_DeviceListContext.AllDeviceListContext.Provider, {
        value: data
      }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        path: (0, _System.getScreenPath)("PlantTwin") + "/*",
        element: /*#__PURE__*/_react["default"].createElement(_CheckAccessRoute.CheckAccessRoute, {
          permission: "PLANT_TWIN",
          component: _PlantTwinScreen.PlantTwinScreen
        })
      })));
    }));
  });
});
function load(collection) {
  return collection.search();
}